import React from 'react'
import { withRouter } from 'react-router-dom'
import { postMessage } from '../../utils'
import Icon1 from '../../assets/img/integral-icon-1.png'
import Icon2 from '../../assets/img/integral-icon-2.png'
import Icon3 from '../../assets/img/integral-icon-3.png'
import PropTypes from 'prop-types'

class IntegralInlineBlockItem extends React.PureComponent {
  static defaultProps = {
    src: null,
    title: '',
    sub: '',
    buttonText: '进入',
    onButtonClick: function () {}
  }

  render () {
    const {
      title,
      sub,
      buttonText,
      onButtonClick,
      src,
      ...props
    } = this.props
    return <div className='integral-inline__item' {...props}>
      <div className='integral-inline__title'>{title}</div>
      <div className='integral-inline__sub'>{sub}</div>
      <div className='integral-inline__div'>
        <div className='integral-inline__button' onClick={onButtonClick}>{buttonText}</div>
        <div className='integral-inline__icon'>
          <img src={src} alt='' />
        </div>
      </div>
    </div>
  }
}

@withRouter
class IntegralInlineBlock extends React.PureComponent {
  static defaultProps = {
    eventOpenFlag: true
  }
  static propTypes = {
    eventOpenFlag: PropTypes.bool
  }
  render () {
    return <div className='integral-inline__wrapper'>
      <IntegralInlineBlockItem
        title={'幸运转盘'}
        sub={'每日抽奖 天天惊喜'}
        src={Icon1}
        onClick={this.goTo.bind(this, `${window.PATH.TURNTABLE}?withHeader=1`)}
      />
      <IntegralInlineBlockItem
        title={'抢红包'}
        sub={'每日抢大量积分'}
        src={Icon2}
        onClick={this.goTo.bind(this, window.PATH.RED_PACKET)}
      />
      <IntegralInlineBlockItem
        title={'幸运翻牌'}
        sub={'每日翻牌 奖励多多'}
        src={Icon3}
        onClick={this.goTo.bind(this, `${window.PATH.CARD_GAME}?withHeader=1`)}
      />
    </div>
  }

  goTo = (path) => {
    if(this.props.eventOpenFlag) {
      this.props.history.push(path)
    } else {
      window.toast.info('活动暂未开始')
    }
  }

  forwardTo = () => {
    postMessage({ type: 'redPacket' })
  }

}

export default IntegralInlineBlock
